module.exports = __webpack_public_path__ + "72c581989d314f33618ffd48619efbe2.pdf";